
const AudioMessage = ({ message }) => {
  return (
    <span>
      <audio controls className="max-w-full"><source src={message?.media?.file} type="audio/mpeg" /></audio>
      {message?.message && <div className="mt-2">{message?.message}</div>}
    </span>
  );
};

export default AudioMessage;
